import React, { useEffect, useState } from "react";
import css from "../css/Refer.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import { BsWhatsapp } from "react-icons/bs";

import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaTelegramPlane } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";

const Refer = ({ user }) => {
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
console.log(addsetting, "addsetting");
  const [cardData, setGame] = useState([]);

  const copyCode = (e) => {
    navigator.clipboard.writeText(user?.referral_code || '');

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const copyLink = (e) => {
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referal Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (user === undefined) {
    return null;
  }

  const referralText = `toxicludo दिन में 5 बार withdrawal लो 05 - 10 मिनट में विड्रॉल कर देता हु 5% कमीशन कटता है
कभी भी पेमेंट ले सकते हो अपना जयपुर ,शाहपुरा का ही हु भाई कोई भी दिक्कत नहीं आएगी भाई मेरी जिम्मेदारी है http://toxicludo.com/login/${user?.referral_code || ''}
  
  Your ReferralCode is - ${user?.referral_code || ''}.`;

  return (
    <>
      {/* <Header user={user} /> */}
      <div>
        <div
          className="leftContainer mb_space"
          style={{ minHeight: "100vh", height: "100%" }}
        >
          <section className="refer_page_main_section">
            <div className="refer_page_top_main_box_outer mb-5">
              <div className="refer_page_top_main_box">
                <h2 className="profile_headings">Your Referral Earnings</h2>
              </div>
              <div className="refer_page_top_main_box_inner">
                <div className="refer_page_top_main_box_inner_single bo_le">
                  <h3>Referred Players</h3>
                  <h4>

                    {user?.referral_user?.length || 0}
                  </h4>
                </div>
                <div className="refer_page_top_main_box_inner_single">
                  <h3>Referral Earning</h3>
                  <h4>
                    <span>₹</span>
                    {user?.referral_earning || 0  }
                  </h4>
                </div>
              </div>

            </div>



            <div className="refer_page_top_main_box_outer">
              <div className="refer_page_top_main_box">
                <h2 className="profile_headings">Referral Code</h2>
              </div>
              <div>
                <div className="Refer_code">
                  <h3>{user?.referral_code || ''}</h3>

                  <button onClick={(e) => copyCode(e)}>Copy</button>
                </div>
                <div className="or_div">
                  {" "}
                  <h2>OR</h2>{" "}
                </div>
                <div className="whatsapp_share_btn">
                  <a
                    href={`whatsapp://send?text= toxicludo दिन में 5 बार withdrawal लो 05 - 10 मिनट में विड्रॉल कर देता हु 5% कमीशन कटता है
कभी भी पेमेंट ले सकते हो अपना जयपुर ,शाहपुरा का ही हु भाई कोई भी दिक्कत नहीं आएगी भाई मेरी जिम्मेदारी है toxicludo.com/login/${user?.referral_code || ''}.`}
                  >
                    <BsWhatsapp className="icons" />
                  </a>

                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=#url?text=Play  toxicludo दिन में 5 बार withdrawal लो 05 - 10 मिनट में विड्रॉल कर देता हु 5% कमीशन कटता है
कभी भी पेमेंट ले सकते हो अपना जयपुर ,शाहपुरा का ही हु भाई कोई भी दिक्कत नहीं आएगी भाई मेरी जिम्मेदारी है http://toxicludo.com/login/${user?.referral_code || ''}
                    
                    Your ReferralCode is - ${user?.referral_code || ''} ..http://toxicludo.com/login/${user?.referral_code ||''}Register Now, My refer code is ${user?.referral_code || ''}.`}
                    target='_blank'
                  >
                    {" "}
                    <AiFillFacebook className="icons" />
                  </a>

                  <a
                    href={`https://telegram.me/share/url?url?text=Play  toxicludo दिन में 5 बार withdrawal लो 05 - 10 मिनट में विड्रॉल कर देता हु 5% कमीशन कटता है
कभी भी पेमेंट ले सकते हो अपना जयपुर ,शाहपुरा का ही हु भाई कोई भी दिक्कत नहीं आएगी भाई मेरी जिम्मेदारी है.http://toxicludo.com/login/${user?.referral_code || ''}Register Now, My refer code is ${user?.referral_code || ''}.`}
                    target='_blank'
                  >
                    <FaTelegramPlane className="icons" />
                  </a>

                  <CopyToClipboard text={referralText}>
                    <button
                      className="bg-green refer-button cxy bg3 "
                      onClick={(e) => copyLink(e)}
                    >
                      <FiCopy className="icons" />
                    </button>
                  </CopyToClipboard>
                </div>
              </div>
            </div>

            <div className="refer_page_top_main_box_outer mt-5">
              <div className="refer_page_top_main_box">
                <h2 className="profile_headings">How It Works</h2>
              </div>
              <div className="refer_page_top_main_box_inner">
                <div className="refer_rules">
                  <p>
                    1. You can refer and Earn 3% of your referral winning, every
                    time
                  </p>
                  <p>
                    2. Like if your player plays for More Amount. 10000 and
                    wins, You will get Ruppe. 300 as referral amount.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Refer;
